import { t } from '@ulule/localize'

export const ERROR_MESSAGE = 'ERROR_MESSAGE'
export const SUCCESS_MESSAGE = 'SUCCESS_MESSAGE'
export const INFO_MESSAGE = 'INFO_MESSAGE'
export const CLEAN_MESSAGE = 'CLEAN_MESSAGE'

const createMessage = (type = '', status = '', messages = [], id) => {
  let message = { type, status, messages }

  if (id !== undefined) {
    message = {
      ...message,
      id
    }
  }

  return message
}

export const errorMessage = createMessage.bind(null, ERROR_MESSAGE, 'error')

export const internalErrorMessage = () =>
  errorMessage([{ message: t('Oops, an internal error has occurred... Please retry!') }], 'internal_error')

export const successMessage = createMessage.bind(null, SUCCESS_MESSAGE, 'success')

export const infoMessage = createMessage.bind(null, INFO_MESSAGE, 'info')

export const cleanMessage = param => ({
  type: CLEAN_MESSAGE,
  param
})
